import { Component, OnInit, ViewChild } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Router } from '@angular/router';
import { CampaignId } from '../../module/campaign-util/shared/campaign-id';
import { SessionManager } from '../../session/service/session-manager';

@Component({
  selector: 'admin-sidebar',
  templateUrl: 'admin-sidebar.component.html',
  styleUrls: [ 'admin-sidebar.component.scss' ],
  animations: [
    trigger('toggleHeight', [
      state('inactive', style({
        height: '0',
        opacity: '0'
      })),
      state('active', style({
        height: '*',
        opacity: '1'
      })),
      transition('inactive <=> active', [
        animate('250ms ease-out')
      ])
    ])
  ]
})
export class AdminSidebarComponent implements OnInit {

  identity: any;
  selectedItem: string;

  @ViewChild('listNavigation', { static: false })
  listNavigation;

  constructor(private campaignId: CampaignId, private router: Router, private sessionManager: SessionManager) {
  }

  ngOnInit() {
    this.sessionManager.getIdentity()
      .subscribe(
        (data: any) => {
          this.identity = data;
        }
      );
  }

  onListElementClick(event: Event, element: HTMLElement) {
    event.preventDefault();
    for (const child of this.listNavigation.nativeElement.children) {
      child.classList.remove('active');
    }
    if (element.classList.contains('active')) {
      element.classList.remove('active');
    } else {
      element.classList.add('active');
    }
  }
}
